import type { SkillGroupType } from "../types/content";

export const skillGroups: SkillGroupType[] = [
  {
    title: "Programming",
    label: "Core languages",
    skills: ["Python", "C++", "C#", "JavaScript", "TypeScript", "HTML", "CSS"],
  },
  {
    title: "AI & Machine Learning",
    label: "Models and perception",
    skills: [
      "Machine Learning",
      "Computer Vision",
      "Object Detection",
      "PyTorch",
      "TensorFlow",
      "OpenCV",
      "NLP",
      "Retrieval-Augmented Generation",
      "Model integration",
    ],
  },
  {
    title: "Robotics & Embedded",
    label: "Physical systems",
    skills: [
      "Raspberry Pi",
      "Arduino",
      "LiDAR",
      "Ultrasonic sensors",
      "Camera perception",
      "Motor control",
      "Serial communication",
      "Autonomous navigation",
      "Robotic prototyping",
    ],
  },
  {
    title: "Web & Applications",
    label: "Product engineering",
    skills: [
      "React",
      "Node.js",
      "FastAPI",
      "ASP.NET MVC",
      ".NET Core",
      "REST APIs",
      "Responsive interfaces",
      "Authentication concepts",
    ],
  },
  {
    title: "Data Engineering & Analytics",
    label: "Data systems",
    skills: [
      "Databricks",
      "PySpark",
      "SQL",
      "Power BI",
      "DAX",
      "ETL",
      "Medallion architecture",
      "Data modelling",
      "Migration testing",
    ],
  },
  {
    title: "Databases & Tools",
    label: "Engineering environment",
    skills: [
      "MongoDB",
      "Oracle",
      "Schema design",
      "Git",
      "GitHub",
      "Linux",
      "Docker",
      "Cloudflare",
      "CI/CD concepts",
      "Technical documentation",
    ],
  },
];

export const currentFocus = [
  "Computer Vision",
  "Production-oriented AI",
  "Robotics",
  "NLP & retrieval",
  "AI-enhanced web applications",
  "Scalable data systems",
  "Autonomous systems",
  "Cloudflare deployment",
  "Modern full-stack engineering",
] as const;
